import { type ReactNode } from 'react';

interface AnelProps {
  /** 0 a 100. */
  valor: number;
  rotulo: string;
  children?: ReactNode;
  concluido?: boolean;
}

const RAIO = 42;
const CIRCUNFERENCIA = 2 * Math.PI * RAIO;

/** Anel que fecha conforme o processamento avança; ao concluir, troca a cor para sucesso. */
export function AnelProgresso({ valor, rotulo, children, concluido = false }: AnelProps) {
  const limitado = Math.max(0, Math.min(100, valor));
  return (
    <div
      role="progressbar"
      aria-label={rotulo}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(limitado)}
      className="relative grid size-28 place-items-center"
    >
      <svg viewBox="0 0 100 100" className="absolute inset-0 -rotate-90" aria-hidden>
        <circle
          cx="50"
          cy="50"
          r={RAIO}
          fill="none"
          strokeWidth="7"
          className="stroke-superficie-afundada"
        />
        <circle
          cx="50"
          cy="50"
          r={RAIO}
          fill="none"
          strokeWidth="7"
          strokeLinecap="round"
          strokeDasharray={CIRCUNFERENCIA}
          strokeDashoffset={CIRCUNFERENCIA * (1 - limitado / 100)}
          className={`transition-[stroke-dashoffset,stroke] duration-[var(--duracao-lenta)] ease-saida ${concluido ? 'stroke-sucesso' : 'stroke-marca'}`}
        />
      </svg>
      <div className="relative grid place-items-center text-center">{children}</div>
    </div>
  );
}
